<template>
    <div class="login-wrap">
        <transition name="slide-fade">
            <div class="ms-login" v-if="isShow">
                <div class="ms-bg">
                    <h2 class="ms-title"></h2>
                    <img src="../../assets/img/login.png" alt="" />
                </div>
                <div class="ms-content">
                    <h2 class="login-title">管理员登录</h2>
                    <div class="login-divide-line"></div>
                    <h4 class="login-tip"></h4>
                    <el-form :model="param" :rules="rules" ref="login" label-width="0px">
                        <el-form-item prop="userName">
                            <el-input
                                :autofocus="true"
                                prefix-icon="el-icon-user"
                                v-model="param.userName"
                                placeholder="请输入登录账号"
                                size=""
                            >
                            </el-input>
                        </el-form-item>
                        <el-form-item prop="password">
                            <el-input
                                prefix-icon="el-icon-lock"
                                type="password"
                                placeholder="请输入登录密码"
                                v-model="param.password"
                                size=""
                                @keyup.enter.native="submitForm()"
                            >
                            </el-input>
                        </el-form-item>
                        <div class="login-btn">
                            <el-button type="primary" @click="submitForm()">登录</el-button>
                        </div>
                    </el-form>
                </div>
            </div>
        </transition>
    </div>
</template>

<script>
import { setStorage } from '@/utils/index.js';
import { login } from '@/api/user.js';
import { get } from '@/utils/request.js';
export default {
    data: function () {
        return {
            isShow: false,
            param: {
                userName: '',
                password: ''
            },
            rules: {
                userName: [{ required: true, message: '请输入登录账号', trigger: 'blur' }],
                password: [{ required: true, message: '请输入登录密码', trigger: 'blur' }]
            }
        };
    },
    mounted() {
        this.isShow = true;
    },
    methods: {
        submitForm() {
            this.$refs.login.validate((valid) => {
                if (valid) {
                    login(this.param).then((res) => {
                        console.log({ res });
                        if (res.success) {
                            this.$message.success('登录成功');
                            setStorage('token', res.token);
                            setStorage('refreshToken', res.refreshToken);
                            this.$router.push('/');
                        } else {
                            this.$message.error(res.msg);
                        }
                    });
                } else {
                    this.$message.error('请输入账号和密码');
                    return false;
                }
            });
        }
    }
};
</script>

<style>
.slide-fade-enter-active {
    transition: all 0.5s cubic-bezier(1, 0.5, 0.8, 1);
}
.slide-fade-leave-active {
    transition: all 0.2s cubic-bezier(1, 0.5, 0.8, 1);
}
.slide-fade-enter,
.slide-fade-leave-to {
    transform: translateY(-1999px);
}
.slide-fade-enter-to {
    transform: translateY(0);
}
.login-wrap {
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    /* background-color: #3c8dbc; */
    background: url('../../assets/img/login-background.png') no-repeat;
    background-size: 100% 100%;
}
.ms-login {
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 80%;
    max-width: 1400px;
    height: 60%;
}
.ms-bg {
    position: relative;
    width: 594px;
    height: 585px;
    border-radius: 20px;
    margin-right: 100px;
}
.ms-bg img {
    width: 100%;
    height: 100%;
    border-radius: 4px;
}
.ms-title {
    position: absolute;
    top: 10%;
    left: 10%;
    line-height: 50px;
    font-size: 30px;
    color: #fff;
}
.ms-content {
    display: flex;
    flex-direction: column;
    justify-content: center;
    width: 350px;
    height: 500px;
    padding: 30px;
    border-radius: 4px;
    background-color: #fff;
    box-shadow: 0 0 10px rgb(0 0 0 / 20%);
    -webkit-box-shadow: 0 0 10px rgb(0 0 0 / 20%);
    -moz-box-shadow: 0 0 10px rgb(0 0 0 / 20%);
}
.login-title {
    margin: 5% 0 20px;
    font-size: 32px;
    font-weight: 500;
    color: #4b62ea;
    text-align: center;
}

.login-divide-line {
    border-bottom: 1px solid #ddd;
    margin-bottom: 30px;
}

.login-tip {
    font-size: 18px;
    color: #b0aabf;
}

/* @supports (display: flex) {
    @media screen and (min-width: 768px) {
        .ms-bg {
            position: relative;
            width: 40%;
            height: 100%;
            border-radius: 20px;
            margin-right: 100px;

            box-shadow: 0 0 10px rgb(0 0 0 / 20%);
            -webkit-box-shadow: 0 0 10px rgb(0 0 0 / 20%);
            -moz-box-shadow: 0 0 10px rgb(0 0 0 / 20%);
        }
        .ms-bg img {
            width: 100%;
            height: 100%;
            border-radius: 4px;
        }
        .ms-title {
            position: absolute;
            top: 10%;
            left: 10%;
            line-height: 50px;
            font-size: 30px;
            color: #fff;
        }
        .ms-content {
            display: flex;
            flex-direction: column;
            justify-content: center;
            width: 28%;
            height: 80%;
            padding: 50px;
            border-radius: 4px;
            background-color: #fff;
            box-shadow: 0 0 10px rgb(0 0 0 / 20%);
            -webkit-box-shadow: 0 0 10px rgb(0 0 0 / 20%);
            -moz-box-shadow: 0 0 10px rgb(0 0 0 / 20%);
        }
        .login-title {
            margin: 20% 0 5px;
            font-size: 18px;
            font-weight: 500;
            color: #4b62ea;
            text-align: center;
        }

        .login-divide-line {
            border-bottom: 1px solid #ddd;
            margin-bottom: 30px;
        }

        .login-tip {
            font-size: 18px;
            color: #b0aabf;
        }
    }
    @media screen and (max-width: 768px) {
        .ms-bg {
            display: none;
        }

        .ms-title {
            display: none;
        }
        .ms-content {
            display: flex;
            flex-direction: column;
            justify-content: center;
            width: 100%;
            padding: 30px 30px;
            border-radius: 4px;
            background-color: #fff;
        }
        .login-title {
            margin: 10% 0 5px;
            font-size: 18px;
            font-weight: bold;
            color: #4b62ea;
            text-align: center;
        }

        .login-tip {
            font-size: 18px;
            color: #b0aabf;
        }

        .login-divide-line {
            border-bottom: 1px solid #ddd;
            margin-bottom: 30px;
        }
    }
} */

.el-input--medium .el-input__inner {
    height: 60px;
    font-size: 16px;
}

.el-input--medium .el-input__icon {
    font-size: 18px;
}

.login-btn {
    margin-top: 30px;
    margin-bottom: 20%;
    text-align: center;
}
.login-btn button {
    margin-top: 20px;
    width: 100%;
    height: 50px;
    font-size: 20px;
}
</style>
